/* @zyf2e/monitor-types version ' + 2.1.55 */
var EMethods;
(function (EMethods) {
    EMethods["Get"] = "GET";
    EMethods["Post"] = "POST";
    EMethods["Put"] = "PUT";
    EMethods["Delete"] = "DELETE";
})(EMethods || (EMethods = {}));

function isReportDataType(data) {
    return data.actionType === undefined && !data.isTrackData;
}

var EActionType;
(function (EActionType) {
    EActionType["PAGE"] = "PAGE";
    EActionType["EVENT"] = "EVENT";
    EActionType["VIEW"] = "VIEW";
    EActionType["DURATION"] = "DURATION";
    EActionType["DURATION_VIEW"] = "DURATION_VIEW";
    EActionType["OTHER"] = "OTHER";
})(EActionType || (EActionType = {}));

export { EActionType, EMethods, isReportDataType };
/* follow me on Github! @cjinhuo */
//# sourceMappingURL=types.esm.js.map
